import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import BaseText from '../BaseText';
import Icon from '../Icon';
import { Color, CommonStyles, CommonProperties } from '../../styles';
import { scale } from '../../utils/scale.utils';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import { searchTypesEnum } from '../../constants/Enums';

const departureIconMap = {
  air: 'plane',
  hotel: 'hotel',
  car: 'car',
  rail: 'rail',
};

const SearchArrivalCityDisplay = (props) => {
  const { t } = useTranslation(i18nNS.searchWidget);
  const { tKey } = useComponentTKey('SearchArrival');
  const { toCity, geolocation, arrivalAirport, dominantSearchType, subSearchType } = props;

  const innerText = () => {
    if (subSearchType != 'multicity') {
      if (dominantSearchType === searchTypesEnum.HOTEL) {
        if ((!toCity && geolocation) || toCity === geolocation?.airportCode) {
          return (
            <BaseText style={styles.innerText}>
              {t(tKey('CurrentLocation'))} ({geolocation.airportCode})
            </BaseText>
          );
        }
      }
    }

    if (!toCity) {
      return <BaseText style={styles.innerText}> {t(tKey('To'))}</BaseText>;
    }
    return (
      <>
        {toCity.length === 3 && <BaseText style={styles.cityText}>{toCity}</BaseText>}
        <BaseText style={[CommonStyles.flex1, styles.innerText]}>{arrivalAirport}</BaseText>
      </>
    );
  };

  return (
    <View style={styles.containerRow}>
      {!!dominantSearchType && (
        <Icon
          size={28}
          name={departureIconMap[dominantSearchType]}
          style={dominantSearchType === 'air' ? styles.flippedIcon : CommonStyles.mr3}
          color={Color.text.low}
        />
      )}
      {innerText()}
    </View>
  );
};

const styles = StyleSheet.create({
  containerRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  flippedIcon: {
    transform: [{ rotateY: '180deg' }],
    ...CommonProperties.mr3,
  },
  innerText: {
    color: Color.grayText,
    ...CommonProperties.small,
  },
  cityText: {
    minWidth: scale(48),
    ...CommonProperties.h2,
    ...CommonProperties.mr3,
  },
});

export default memo(SearchArrivalCityDisplay);
